export const config: AppConfig = window.__CONFIG__;

/** Official style used until a Mapbox Studio style is configured. */
export const DEFAULT_MAPBOX_STYLE_URL = "mapbox://styles/mapbox/streets-v12";

/** Empty / placeholder tokens must not reach Mapbox — the locator shows a
 *  setup notice instead of a broken canvas. */
export const mapboxToken = (config.MAPBOX_TOKEN ?? "").trim().startsWith("pk.")
  ? (config.MAPBOX_TOKEN as string).trim()
  : "";

export const mapboxStyleUrl =
  (config.MAPBOX_STYLE_URL ?? "").trim() || DEFAULT_MAPBOX_STYLE_URL;
